export const MyInfoLogo = require("./myInfo.svg");
export const MyInfoBtn = require("./myInfoBtn.svg");
export const UploadIcon = require("./ic_upload.svg");
export const SingPass = require("./singPass.svg");
